<template>
  <div class="review">
    <div class="rightmouse" :style="{ top: rightMouseTop + 'px', left: rightMouseLeft + 'px' ,opacity : rightMouseFlag ? '1' : '0'}">
      <p>© 图片版权保护</p>
    </div>
    <div class="reviewheader"
    :style="{'backgroundColor': isCustom ? customColor : isSimple ? '#E27B02' : '#185ED3'}">
      <div class="left">
        <div class="all"
        :style="{'backgroundColor': isSimple ? '#185ED3' : '#E27B02'}">
          待审核
          <span>{{chooseTotal}}</span>张
        </div>
        <div>{{$route.query.currentUsername}}</div>
        <p>邀请您完成复审，请在正文已选图片中操作，如需增补图片请切换模式</p>
        <el-switch v-model="change"
                   active-color="#13ce66"
                   :inactive-color="isSimple?'#185ED3':'#E27B02'"></el-switch>
        <p v-if="change"
           @click="change = !change"
           class="switchtext">审核模式</p>
        <p v-if="!change"
           @click="change = !change"
           class="switchtext mover">增补模式</p>
      </div>
      <div class="right">
        <button @click="savePic" :style="{'backgroundColor': isSimple ? '#185ED3' : '#E27B02'}">保存</button>
      </div>
    </div>

    <!-- 审核模式 -->
    <div @scroll="checkScroll($event)"
         v-if="change"
         @click="descdialog = false"
         class="reviewnr">
      <section ref="check">
        <div @click="openDialogChoose(index,item)"
             class="img-wrapper"
             v-for="(item, index) in chooseList"
             :key="index">
          <img class="img"
               @contextmenu.prevent="rightShow($event)"
               ondragstart="return false;"
               :src="item.src" />

          <el-tooltip class="item"
                      effect="dark"
                      content="移除图片"
                      placement="top">
            <div @click.stop="removePic(index,item)"
                 class="choosethis">
              <img src="@/assets/sreenpic/close.png"
                   alt />
            </div>
          </el-tooltip>

          <el-tooltip class="item"
                      effect="dark"
                      content="查看备注"
                      placement="top">
            <div @click.stop="openAllDesc(item)"
                 class="choosedesc">
              <img src="@/assets/sreenpic/msg.png"
                   alt />
            </div>
          </el-tooltip>

          <el-tooltip class="item"
                      effect="dark"
                      content="添加备注"
                      placement="top">
            <div @click.stop="openDesc(item)"
                 class="writedesc">
              <img src="@/assets/sreenpic/desc.png"
                   alt />
            </div>
          </el-tooltip>
        </div>
      </section>
      <img v-if="showLoading"
           width="200px"
           style="margin-left: 40%;"
           src="@/assets/blue-preloader.gif"
           alt />
      <template>
        <div class="nonr"
             v-if="chooseList.length === 0">
          <img src="@/assets/piclist/nonr.png"
               alt="">
        </div>
      </template>
    </div>

    <el-collapse-transition>
      <div @click.stop
           v-if="descdialog && change"
           class="picdescribe">
        <p>图片备注：</p>
        <div class="descoper">
          <el-input class="describeinput"
                    v-model="picDescribe"
                    placeholder="内容文字不超过200字"></el-input>
          <button @click="addDesc">备注</button>
        </div>
      </div>
    </el-collapse-transition>

    <!-- 增补模式 -->

    <div v-if="!change"
         class="choosebackground">
      <div class="alternative">
        <div class="choosehead">
          <h3>备选图片</h3>
          <div>
            共
            <span class="big">{{actTotal}}</span>篇投稿 /
            <span class="big">{{picTotal}}</span>张图片
            （已忽略稿件
            <span class="big">{{rejectCount}}</span>篇）
          </div>
        </div>

        <div @scroll="alternativeScroll($event)"
             class="nr">
          <div ref="nr"
               style="min-height:100%"
               v-loading='actLoading'>
            <div class="actinfo"
                 v-for="(e,i) in actList"
                 :key="i">
              <div class="acthead">
                <div class="name">
                  <span>{{e.title}}</span>
                  ·
                  <span>{{e.createUserName}}</span>
                  ·
                  <span>{{e.createUserMobile}}</span>
                </div>
                <div class="btnbj">
                  <!-- <button class="clear">一键清除</button> -->
                  <button @click="seeall(e)"
                          class="seeall">浏览正文</button>
                </div>

                <div v-if="powersObj.rejectPictureArticleFilter"
                     @click="closeAct(e)"
                     class="close">
                  <img width="13"
                       height="13"
                       src="@/assets/sreenpic/close.png"
                       alt />
                </div>
              </div>
              <div class="pic">
                <section>
                  <div @click="openDialog(i,index,item)"
                       class="img-wrapper"
                       v-for="(item, index) in e.imgs"
                       :key="index">
                    <img width="160"
                         @contextmenu.prevent="rightShow($event)"
                         ondragstart="return false;"
                         class="img"
                         :src="item.src" />

                    <el-tooltip class="item"
                                effect="dark"
                                content="添加图片"
                                placement="top">
                      <div @click.stop="choosethis(i,index,item)"
                           class="choosethis">
                        <img src="@/assets/sreenpic/plus.png"
                             alt />
                      </div>
                    </el-tooltip>

                    <div v-if="item.isChoose"
                         class="imgchoose">
                      <img src="@/assets/sreenpic/choose.png"
                           alt />
                    </div>
                  </div>
                </section>

              </div>
            </div>
            <img v-if="showLoading1"
                 width="200px"
                 style="margin-left: 40%;"
                 src="@/assets/blue-preloader.gif"
                 alt />
          </div>
        </div>
      </div>

      <div class="selected">
        <div class="choosehead">
          <h3>
            已选入 /
            <span>{{chooseTotal}}</span>张
          </h3>
        </div>

        <div @scroll="selectedScroll($event)"
             class="nr"
             v-loading='chooseLoading'>
          <section ref="selected">
            <div @click="openDialogChoose(index,item)"
                 class="img-wrapper"
                 v-for="(item, index) in chooseList"
                 :key="index">
              <img class="img"
                   @contextmenu.prevent="rightShow($event)"
                   ondragstart="return false;"
                   :src="item.src" />

              <el-tooltip class="item"
                          effect="dark"
                          content="移除图片"
                          placement="top">
                <div @click.stop="removePic(index,item)"
                     class="choosethis">
                  <img src="@/assets/sreenpic/close.png"
                       alt />
                </div>
              </el-tooltip>

              <el-tooltip class="item"
                          effect="dark"
                          content="查看备注"
                          placement="top">
                <div @click.stop="openAllDesc(item)"
                     class="choosedesc">
                  <img src="@/assets/sreenpic/msg.png"
                       alt />
                </div>
              </el-tooltip>

              <el-tooltip class="item"
                          effect="dark"
                          content="添加备注"
                          placement="top">
                <div @click.stop="openDesc(item)"
                     class="writedesc">
                  <img src="@/assets/sreenpic/desc.png"
                       alt />
                </div>
              </el-tooltip>

            </div>
          </section>

          <template>
            <div class="nonr"
                 v-if="chooseList.length === 0">
              <img src="@/assets/piclist/nonr.png"
                   alt="">
            </div>
          </template>
          <img v-if="showLoading"
               width="200px"
               style="margin-left: 35%;"
               src="@/assets/blue-preloader.gif"
               alt />
        </div>
        <el-collapse-transition>
          <div @click.stop
               v-if="descdialog"
               class="picdescribe">
            <p>图片备注：</p>
            <div class="descoper">
              <el-input class="describeinput"
                        v-model="picDescribe"
                        placeholder="内容文字不超过200字"></el-input>
              <button @click="addDesc">备注</button>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
    <picdescdialog :messageList="messageList"
                   @handleClose="handleClose"
                   :dialogVisible="descdialogVisible"></picdescdialog>

    <picview v-if="picdialogVisible"
             :dialogVisible="picdialogVisible"
             @handleClose="handleClosepic"
             :passChoose='passChoose'
             :picList='picList'></picview>

    <el-dialog :visible.sync="condialogVisible"
               width="30%"
               :before-close="conhandleClose">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>正文内容</div>
      </div>
      <div style="max-height:500px;overflow-y: auto;">{{actCon || '暂无'}}</div>
    </el-dialog>
  </div>
</template>

<script>
import { picdescdialog } from "@/components/index";
import picview from '@/components/picView/picView'
import { getDate, formatConversion } from "@/plugins/getdate";
import {
  listPictureActivityArticle,
} from "@/api/pictureActivityArticle";
import { powersObj } from "@/constants/powers";
import {
  selectPicture,
  listSelect,
  listCheck,
  unSelectPicture,
  addMessage,
  listMessage,
  rejectPictureArticle,
  listArticle,
  getTask
} from "@/api/workflow";

import {
  getPictures
} from "@/api/picture";

import { picPrefix } from "@/constants/piccommon";


export default {
  components: {
    picdescdialog, picview
  },
  data () {
    return {
      //权限
      powersObj,
      //浏览正文
      actCon: '',
      condialogVisible: false,

      //备注相关
      messageList: [],
      descForm: {},


      passChoose: {},
      picList: [],
      picdialogVisible: false,
      change: true,
      chooseLoading: false,
      actLoading: false,
      actTotal: 0,
      chooseTotal: 0,
      picTotal: 0,
      rejectCount: 0,
      descdialogVisible: false,
      descdialog: false,
      picDescribe: '',

      totalChoose: 0,
      currentPageChoose: 1,
      pageSizeChoose: 20,
      chooseList: [],

      totalAct: 0,
      currentPageAct: 1,
      pageSizeAct: 10,
      actList: [],

      totalCheck: 0,
      currentPageCheck: 1,
      pageSizeCheck: 20,
      checkList: [],
      picPrefix,
      showLoading: false,
      showLoading1: false,
      passFlag: true,


      //鼠标右击
      rightMouseTop:0,
      rightMouseLeft:0,
      rightMouseFlag:false,
    };
  },
  methods: {

    //图片右击
    rightShow(e){
      this.rightMouseLeft = e.clientX
      this.rightMouseTop = e.clientY
      setTimeout(() => {
        this.rightMouseFlag = true
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false
      }, 2000);
      // this.$message('版权所有')
    },


    //滚动加载事件
    //审核滚动事件
    checkScroll (e) {
      // console.log(this.$refs.check.offsetHeight)
      // console.log(e.srcElement.scrollTop, e.target.scrollTop)
      if (e.srcElement.scrollTop + 667 >= this.$refs.check.offsetHeight) {
        if (this.chooseList.length !== this.chooseTotal && this.passFlag) {
          console.log(1)
          this.passFlag = false
          this.showLoading = true
          this.currentPageChoose++;
          let dataActList = { page: (this.currentPageChoose - 1), pageSize: this.pageSizeChoose, pictureArticleFilterTaskId: this.$route.query.pictureArticleFilterTaskId }
          setTimeout(() => {
            this.listSelectAsync(dataActList)
          }, 1000);
        }
      }
    },
    //已选图片滚动事件
    selectedScroll (e) {
      // console.log(this.$refs.selected.offsetHeight)
      // console.log(e.srcElement.scrollTop, e.target.scrollTop)
      if (e.srcElement.scrollTop + 667 >= this.$refs.selected.offsetHeight) {
        console.log();
        if (this.chooseList.length !== this.totalChoose && this.passFlag) {
          this.currentPageChoose++;
          console.log(this.currentPageChoose);
          let dataActList = { page: (this.currentPageChoose - 1), pageSize: this.pageSizeChoose, pictureArticleFilterTaskId: this.$route.query.pictureArticleFilterTaskId }
          this.showLoading = true
          this.passFlag = false
          setTimeout(() => {
            this.listSelectAsync(dataActList)
          }, 1000);
        }
      }
    },
    //备选图片滚动事件
    alternativeScroll (e) {
      // console.log(e)
      // console.log(this.$refs.nr.offsetHeight)
      // console.log(e.srcElement.scrollTop, e.target.scrollTop)

      if (e.srcElement.scrollTop + 667 >= this.$refs.nr.offsetHeight) {
        if (this.actList.length !== this.totalAct && this.passFlag) {
          this.passFlag = false
          this.showLoading1 = true
          this.currentPageAct++;
          let dataActList = { page: (this.currentPageAct - 1), pageSize: this.pageSizeAct, pictureArticleFilterTaskId: this.$route.query.pictureArticleFilterTaskId }
          setTimeout(() => {
            this.listPictureActivityArticleAsync(dataActList)
          }, 2000);
        }
      }
    },

    //屏蔽稿件
    closeAct (e) {
      this.$confirm('确认移除该稿件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      }).then(() => {
        this.actLoading = true
        let data = {
          pictureArticleFilterTaskId: this.$route.query.pictureArticleFilterTaskId,
          pictureActivityId: e.pictureActivityId,
          pictureActivityArticleId: e.id,
        }
        this.rejectPictureArticleAsync(data)
      }).catch(() => {

      });

    },
    //关闭浏览正文
    conhandleClose () {
      this.condialogVisible = false
    },

    //
    seeall (e) {
      this.actCon = e.content
      this.condialogVisible = true
    },
    //图片描述
    openDesc (e) {
      this.descdialog = true
      this.descForm = {
        pictureActivityArticleId: e.pictureActivityArticleId,
        pictureActivityId: e.pictureActivityId,
        pictureArticleFilterTaskId: e.pictureArticleFilterTaskId,
        pictureId: e.pictureId
      }
    },
    addDesc () {
      if (this.picDescribe == '') {
        this.$message.warning('请填写内容！')
      } else {
        this.descForm.message = this.picDescribe
        this.addMessageAsync(this.descForm)
        this.picDescribe = ''

      }
    },
    openAllDesc (e) {
      this.descdialogVisible = true
      let data = {
        pictureArticleFilterTaskId: e.pictureArticleFilterTaskId,
        pictureId: e.pictureId
      }
      this.listMessageAsync(data)
    },

    //关闭图片浏览
    handleClosepic () {
      this.picdialogVisible = false
    },
    //图片描述
    blurDesc () { },
    opendesc () {
      this.descdialog = true;
    },
    openDialogChoose (i, e) {
      this.descdialog = false
      this.passChoose = e
      this.passChoose.desc = e.pictureInfo.desc
      this.passChoose.myId = i
      for (let z = 0; z < this.chooseList.length; z++) {
        this.chooseList[z].myId = z
      }
      console.log(this.chooseList[0])
      this.picList = this.chooseList
      this.picdialogVisible = true
    },
    openDialog (i, ci, e) {
      this.descdialog = false
      this.passChoose = e
      this.passChoose.myId = ci
      for (let z = 0; z < this.actList[i].imgs.length; z++) {
        this.actList[i].imgs[z].myId = z
      }
      this.picList = this.actList[i].imgs
      this.picdialogVisible = true
    },
    handleClose () {
      this.descdialogVisible = false
    },
    //选择图片
    choosethis (i, ci, e) {
      this.actList[i].imgs[ci].isChoose = true

      let choosepic = {
        pictureArticleFilterTaskId: this.$route.query.pictureArticleFilterTaskId,
        pictureActivityId: this.$route.query.id,
        pictureActivityArticleId: e.pictureActivityArticleId,
        pictureId: e.id
      }
      this.selectPictureAsync(choosepic)

    },

    //保存图片
    savePic () {
      this.$confirm('确定保存吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      }).then(() => {
        this.$emit('savePic', this.chooseList)
      }).catch(() => {

      });
    },

    //取消选入
    removePic (i, e) {

      let removeChoose = {
        pictureArticleFilterTaskId: e.pictureArticleFilterTaskId,
        pictureActivityId: e.pictureActivityId,
        pictureActivityArticleId: e.pictureActivityArticleId,
        pictureId: e.pictureId
      }
      this.unSelectPictureAsync(removeChoose)
      // console.log(e)
    },


    //添加备注
    async addMessageAsync (val) {
      let { status, data, message } = await addMessage(val);
      if (status) {
        this.descdialog = false
        this.$message.success('添加成功！')
      } else {
        this.descdialog = false
        this.$message.error('添加失败！')
      }
    },

    //查看所有备注
    async listMessageAsync (val) {
      let { status, data, message, errors } = await listMessage(val);
      if (status) {
        this.messageList = []

        for (let i = 0; i < data.length; i++) {
          data[i].createAtMy = formatConversion(data[i].createAt.toString())
          data[i].createUserName = data[i].createUserInfo.name
        }
        this.messageList = data
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //屏蔽图片筛选任务的投稿
    async rejectPictureArticleAsync (val) {
      let { status, data, message } = await rejectPictureArticle(val);
      if (status) {
        this.$message.success('移除成功！')
        let dataActList = { page: (this.currentPageAct - 1), pageSize: this.pageSizeAct, pictureArticleFilterTaskId: this.$route.query.pictureArticleFilterTaskId }
        this.listPictureActivityArticleAsync(dataActList)
        this.getTaskAsync(this.$route.query.pictureArticleFilterTaskId)
      } else {
        this.$message.error('移除失败！')
      }
    },

    //获取选入图片列表
    async listSelectAsync (val) {
      let { status, data, message, pagination } = await listSelect(val);
      if (status) {
        this.chooseTotal = pagination.total
        this.totalChoose = pagination.total
        for (let i = 0; i < data.length; i++) {
          if(data[i].indexpicInfo){
            if(!data[i].indexpicInfo.picThumbW240H160){
              data[i].src = require('@/assets/house/onloadpicin.png')
              data[i].picThumbW1080 = require('@/assets/house/onloadpicin.png')
            }else{
              data[i].src = picPrefix + data[i].indexpicInfo.picThumbW240H160
              data[i].picThumbW1080 = picPrefix + data[i].indexpicInfo.picThumbW1080
            }

            if (data[i].indexpicInfo.picThumbW240H160 === 'error') {
              data[i].src = require('@/assets/house/onloadpicerror.png')
              data[i].picThumbW1080 = require('@/assets/house/onloadpicerror.png')
            }

            let imgTest = new Image()
            imgTest.src = picPrefix + data[i].indexpicInfo.picThumbW240H160
            imgTest.onerror = () => {
              data[i].src = require('@/assets/house/onloadpicerror.png')
              data[i].picThumbW1080 = require('@/assets/house/onloadpicerror.png')
            }
          }else{
            data[i].src = require('@/assets/house/onloadpicin.png')
            data[i].picThumbW1080 = require('@/assets/house/onloadpicin.png')
          }
          data[i].createAtMy = formatConversion(data[i].indexpicInfo.createAt.toString())
        }

        if (this.currentPageChoose == 1) {
          this.chooseList = data
        } else {
          for (let i = 0; i < data.length; i++) {
            this.chooseList.push(data[i])

          }
        }
      }
      this.showLoading = false
      this.passFlag = true
    },

    //选入图片
    async selectPictureAsync (val) {
      let { status, data, message } = await selectPicture(val);
      if (status) {
        this.$message.success('添加成功！')
        let dataChooseList = { page: (this.currentPageChoose - 1), pageSize: this.pageSizeChoose, pictureArticleFilterTaskId: this.$route.query.pictureArticleFilterTaskId }
        this.listSelectAsync(dataChooseList)
      } else {
        this.$message.error('添加失败！')
      }
    },

    //移除图片
    async unSelectPictureAsync (val) {
      let { status, data, message } = await unSelectPicture(val);
      if (status) {
        this.$message.success('移除成功！')
        this.currentPageChoose = 1
        let dataChooseList = { page: (this.currentPageChoose - 1), pageSize: this.pageSizeChoose, pictureArticleFilterTaskId: this.$route.query.pictureArticleFilterTaskId }
        this.listSelectAsync(dataChooseList)
        this.actLoading = true
        this.chooseLoading = true
        this.currentPageAct = 1
        let dataActList = { page: (this.currentPageAct - 1), pageSize: this.pageSizeAct, pictureArticleFilterTaskId: this.$route.query.pictureArticleFilterTaskId }
        this.listPictureActivityArticleAsync(dataActList)
      } else {
        this.$message.error('移除失败！')
      }
    },

    //获取选入图片列表
    async getTaskAsync (val) {
      let { status, data, message, pagination } = await getTask(val);
      if (status) {
        this.actTotal = data.articleCount
        this.picTotal = data.picutreCount
        this.rejectCount = data.rejectCount
      }
    },

    //获取稿件信息
    async listPictureActivityArticleAsync (val) {
      console.log(this.pageSizeAct);
      let { status, data, message, pagination } = await listArticle(val);
      if (status) {
        // this.actTotal = 0
        // this.picTotal = 0
        for (let i = 0; i < data.length; i++) {
          // this.picTotal += data[i].pictureCount
          if (data[i].createUserInfo) {
            data[i].createUserName = data[i].createUserInfo.name
            data[i].createUserMobile = data[i].createUserInfo.mobile
          } else {
            data[i].createUserName = '暂无'
            data[i].createUserMobile = '暂无'
          }

          let imgsList = await getPictures({ ids: data[i].pictureIds })
          for (let j = 0; j < imgsList.data.length; j++) {

            if(imgsList.data[j].fileInfo){
              if(!imgsList.data[j].fileInfo.picThumbW240H160){
                imgsList.data[j].src = require('@/assets/house/onloadpicin.png')
                imgsList.data[j].picThumbW1080 = require('@/assets/house/onloadpicin.png')
              }else{
                imgsList.data[j].src = picPrefix + imgsList.data[j].fileInfo.picThumbW240H160
                imgsList.data[j].picThumbW1080 = picPrefix + imgsList.data[j].fileInfo.picThumbW1080
              }

              if (imgsList.data[j].fileInfo.picThumbW240H160 === 'error') {
                imgsList.data[j].src = require('@/assets/house/onloadpicerror.png')
                imgsList.data[j].picThumbW1080 = require('@/assets/house/onloadpicerror.png')
              }

              let imgTest = new Image()
              imgTest.src = picPrefix + imgsList.data[j].fileInfo.picThumbW240H160
              imgTest.onerror = () => {
                imgsList.data[j].src = require('@/assets/house/onloadpicerror.png')
                imgsList.data[j].picThumbW1080 = require('@/assets/house/onloadpicerror.png')
              }
            }else{
              imgsList.data[j].src = require('@/assets/house/onloadpicin.png')
              imgsList.data[j].picThumbW1080 = require('@/assets/house/onloadpicin.png')
            }

            // imgsList.data[j].src = picPrefix + imgsList.data[j].fileInfo.picThumbW240H160
            // imgsList.data[j].picThumbW1080 = picPrefix + imgsList.data[j].fileInfo.picThumbW1080
            imgsList.data[j].isChoose = false
            imgsList.data[j].pictureActivityArticleId = data[i].id
            imgsList.data[j].createAtMy = formatConversion(imgsList.data[j].createAt.toString())
          }
          data[i].imgs = imgsList.data
        }

        //判断选择图片的位置
        if (this.chooseList.length > 0) {
          for (let i = 0; i < this.chooseList.length; i++) {
            for (let j = 0; j < data.length; j++) {
              if (this.chooseList[i].pictureActivityArticleId === data[j].id) {
                for (let z = 0; z < data[j].imgs.length; z++) {
                  if (this.chooseList[i].pictureId === data[j].imgs[z].id) {
                    data[j].imgs[z].isChoose = true
                  }

                }
              }

            }
          }
        }


        if (this.currentPageAct == 1) {
          this.actList = data
        } else {
          for (let i = 0; i < data.length; i++) {
            this.actList.push(data[i])
          }
        }
        // this.actTotal = this.actList.length
        this.totalAct = pagination.total
        this.actLoading = false
        this.chooseLoading = false
      } else {
        this.$message.error(message)
        this.actLoading = false
        this.chooseLoading = false
      }
      this.passFlag = true
      this.showLoading = false
      this.showLoading1 = false
    }
  },
  created () {
    let dataCheckList = { page: (this.currentPageCheck - 1), pageSize: this.pageSizeCheck, pictureArticleFilterTaskId: this.$route.query.pictureArticleFilterTaskId }
    this.listSelectAsync(dataCheckList)

    this.getTaskAsync(this.$route.query.pictureArticleFilterTaskId)

    this.actLoading = true
    this.chooseLoading = true
    setTimeout(() => {

      let dataActList = { page: (this.currentPageAct - 1), pageSize: this.pageSizeAct, pictureArticleFilterTaskId: this.$route.query.pictureArticleFilterTaskId }
      this.listPictureActivityArticleAsync(dataActList)
    }, 200);
  },
  beforeDestroy () { },
  mounted () { },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
@import "./review.scss";
.el-switch /deep/ .el-switch__core {
  width: 90px !important;
  margin-left: 20px;
}
.nonr {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
